// @ts-check

class ApiEndpoints {
  /** @type {string} Base server URL (API origin) */
  static serverURL = (
    // "http://192.168.1.25:5000"
    (import.meta.env.VITE_API_BASE_URL as string)
    // "https://dc40467c0ba35578.dev.server.gymstream.app"
  ).replace(/\/+$/, "");

  /** @type {string} (Legacy/compat) */
  static baseApiURL = ApiEndpoints.serverURL;

  /** @type {string} Base asset URL */
  static assetURL =
    (import.meta.env.VITE_APP_ASSET_URL as string)
  // "https://gymstream-dev.s3.ap-south-1.amazonaws.com";

  static originalCustomWorkoutURL =
    `${this.assetURL}/files/  /workouts/original`;
  static originalDefaultWorkoutURL =
    `${this.assetURL}/files/app/workouts/original`;

  static customWorkoutThumbnailURL =
    `${this.assetURL}/files/subscriber/workouts/thumbnail`;
  static defaultWorkoutThumbnailURL =
    `${this.assetURL}/files/app/workouts/thumbnail`;

  static convertedCustomWorkoutURL =
    `${this.assetURL}/files/subscriber/workouts/streaming`;
  static convertedDefaultWorkoutURL =
    `${this.assetURL}/files/app/workouts/streaming`;

  /** @type {string} Full  subscriber base path */
  static baseSubscriberApi = `${this.serverURL}/subscriber-service/api/v1`;

  /** @type {string} Full  file base path */
  static baseFileApi = `${this.serverURL}/file-service/api/v1`;

  // for admin
  /** @type {string} */
  static admin = `${this.baseSubscriberApi}/admin`;
  static adminLogin = `${this.admin}/login`;
  static adminGoogleLogin = `${this.admin}/google-login`;
  static adminProfile = `${this.admin}/profile`;
  static getAllAdmin = `${this.admin}/subscriber`;
  static createAdmin = `${this.admin}/subscriber`;
  static adminChangePassword = `${this.admin}/change-password`;
  static adminForgetPassword = `${this.admin}/forget-password`;
  static adminResetPassword = `${this.admin}/reset-password`;
  static adminLogout = `${this.admin}/logout`;
  static adminStatusChange = `${this.admin}/change-status`;
  static adminLoginToken = `${this.admin}/login/token`;
  // for organisation
  /** @type {string} */
  static organisation = `${this.baseSubscriberApi}/organisation`;
  static createOrganisation = `${this.organisation}/subscriber`;
  static getAllOrganisations = `${this.organisation}/subscriber`;
  static editOrganisation = `${this.organisation}`;
  static deleteOrganisation = `${this.organisation}`;
  static organisationStatusChange = `${this.organisation}/change-status`;

  // for gym
  /** @type {string} */
  static gym = `${this.baseSubscriberApi}/gym`;
  static createGym = `${this.gym}/subscriber`;
  static getAllGyms = `${this.gym}/subscriber`;
  static editGym = `${this.gym}`;
  static deleteGym = `${this.gym}`;
  static gymStatusChange = `${this.gym}/change-status`;

  // for staff
  /** @type {string} */
  static staff = `${this.baseSubscriberApi}/staff`;
  static createStaff = `${this.staff}/subscriber`;
  static getAllStaff = `${this.staff}/subscriber`;
  static getStaffById = `${this.staff}`;
  static editStaff = `${this.staff}`;
  static deleteStaff = `${this.staff}`;
  static staffStatusChange = `${this.staff}/change-status`;

  // for subscriber
  /** @type {string} */
  static subscriber = `${this.baseSubscriberApi}/subscriber`;
  static createSubscriber = `${this.subscriber}`;
  static getAllSubscribers = `${this.subscriber}`;
  static getSubscriberById = `${this.subscriber}`;
  static editSubscriber = `${this.subscriber}`;
  static deleteSubscriber = `${this.subscriber}`;

  // for plans
  /** @type {string} */
  static getPlans = `${this.baseSubscriberApi}/plan/subscriber`;
  // for taxes
  /** @type {string} */
  static getTaxes = `${this.baseSubscriberApi}/tax`;

  // for subscription Licenses
  /** @type {string} */
  static addSubscriptionLicenses = `${this.baseSubscriberApi}/subscription`;
  static addOnSubscriptionLicenses = `${this.baseSubscriberApi}/subscription/license`;
  static getSubscription = `${this.baseSubscriberApi}/subscription`;


  static subscriptionInvoice = `${this.baseSubscriberApi}/invoice`;
  static getSubscriptionInvoice = `${this.subscriptionInvoice}`;
  static getSubscriptionInvoiceUpcoming = `${this.subscriptionInvoice}/upcoming/organisation`;

  // for subscription payment
  static createSubscriptionPayment = `${this.baseSubscriberApi}/payment-method`;
  static getSubscriptionPayment = `${this.baseSubscriberApi}/payment-method`;
  static cancelPendingSubscription = `${this.baseSubscriberApi}/subscription/cancel-pending`;
  // for subscription screen
  /** @type {string} */
  static screen = `${this.baseSubscriberApi}/screen`;
  static cancelSubscriberScreen = `${this.screen}/cancel`;
  static resubscribeSubscriberScreen = `${this.screen}/renew`;
  static revokeSubscriberScreen = `${this.screen}/revoke`;
  static getOrganisationScreens = `${this.screen}/organisation`;

  // for subscription license
  static license = `${this.baseSubscriberApi}/license`;
  static assignLicense = `${this.license}/assign/gym`;
  static unAssignLicense = `${this.license}/unassign`;
  static licenseStatusChange = `${this.license}/change-status`;
  static getSubscriberLicenses = `${this.license}`;
  static getOrganisationLicenses = `${this.license}/organisation`;
  static getSubscriptionLicenses = `${this.license}/subscription`;
  static upgradeSubscriberLicense = `${this.license}/upgrade`;
  static downgradeSubscriberLicense = `${this.license}/downgrade`;
  static cancelSubscriberLicense = `${this.license}/cancel`;
  static resubscribeSubscriberLicense = `${this.license}/renew`;
  static revokeSubscriberLicense = `${this.license}/revoke`;


  // for workout
  /** @type {string} */
  static workout = `${this.baseSubscriberApi}/workout`;
  static createWorkout = `${this.workout}/subscriber`;
  static getAllWorkouts = `${this.workout}/subscriber`;
  static getWorkoutById = `${this.workout}`;
  static editWorkout = `${this.workout}`;
  static deleteWorkout = `${this.workout}`;

  // for session
  /** @type {string} */
  static session = `${this.baseSubscriberApi}/session`;
  static createSession = `${this.session}/subscriber`;
  static getAllSessions = `${this.session}/subscriber`;
  static getSessionById = `${this.session}`;
  static editSession = `${this.session}`;
  static deleteSession = `${this.session}`;
  static changeSessionStatus = `${this.session}/change-status`;
  static duplicateSession = `${this.session}`;

  // for session
  /** @type {string} */
  static sessionFormat = `${this.baseSubscriberApi}/session-format`;
  static getSessionFormats = `${this.sessionFormat}/session`;
  static createSessionFormat = `${this.sessionFormat}/session`;
  static updateSessionFormat = `${this.sessionFormat}/session`;
  static createSessionExerciseBeginner = `${this.baseSubscriberApi}/session`;

  // for session format block
  /** @type {string} */
  static sessionFormatBlock = `${this.baseSubscriberApi}/session-format-block`;
  static getSessionFormatBlocks = `${this.sessionFormatBlock}/session`;
  static updateSessionFormatBlock = `${this.sessionFormatBlock}/session`;
  static createSessionFormatBlock = `${this.sessionFormatBlock}/session-format`;
  static getSessionFormatBlocksBySessionFormatId = `${this.sessionFormatBlock}/session-format`;
  static createSessionMatrixBlocks = `${this.sessionFormatBlock}/session-format`;
  static createFormatBlock = `${this.sessionFormatBlock}`;
  static createSessionGroup = `${this.sessionFormatBlock}/group/session-format`;
  static deleteSessionGropuBlockWorkout = `${this.sessionFormatBlock}/remove-workout`;
  static getSessionSummaryBySessionId = `${this.sessionFormatBlock}/session`;

  // for session format
  /** @type {string} */
  static getAllFormats = `${this.baseSubscriberApi}/format/category`;
  static getAllCategories = `${this.baseSubscriberApi}/category/type`;
  static getAllMuscles = `${this.baseSubscriberApi}/muscle`;
  static getAllEquipments = `${this.baseSubscriberApi}/equipment`;
  static getAllMetric = `${this.baseSubscriberApi}/metric`;
  static getAllGroups = `${this.baseSubscriberApi}/group/category`;

  /** @type {string} */
  static sessionSchedule = `${this.baseSubscriberApi}/session-schedule`;
  static assignSessionSchedule = `${this.sessionSchedule}/subscriber`;
  static getAllSessionSchedules = `${this.sessionSchedule}/subscriber`;
  static deleteSessionSchedule = `${this.sessionSchedule}`;
  static getSessionScheduleByGymId = `${this.sessionSchedule}/gym`;

  /** @type {string} */
  static file = `${this.baseFileApi}/file/workout/subscriber`;
  static uploadFile = `${this.file}`;
  static uploadThumbnail = `${this.file}/thumbnail`;

  //for device
  /** @type {string} */
  static device = `${this.baseSubscriberApi}/device`;
  static createDevice = `${this.device}`;
  static getAllDevices = `${this.device}/subscriber`;
  static getDeviceById = `${this.device}`;
  static editDevice = `${this.device}`;
  static deleteDevice = `${this.device}`;
  static changeForceLogout = `${this.device}/change-force-logout`;



  static theme = `${this.baseSubscriberApi}/theme`;
  static getDefaultTheme = `${this.theme}/default`;
  static createTheme = `${this.theme}/subscriber`;
  static getThemesByOrg = `${this.theme}/organisation`;
  
  
}

export default ApiEndpoints;
